var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselItem1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26951_23025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 65,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 83 65)",
    fill: "#F2E9FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.5,
    cy: 50.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 141.5 50.5)",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.591 63.3477C133.209 72.9656 129.311 92.4576 114.884 106.884C100.457 121.311 80.9652 125.21 71.3473 115.592C61.7295 105.974 65.6279 86.4819 80.0547 72.0551C94.4815 57.6283 113.974 53.7299 123.591 63.3477Z",
    stroke: "url(#paint0_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.946 119.945C142.372 105.518 146.271 86.0261 136.653 76.4082L123.592 63.3472C133.209 72.965 129.311 92.4571 114.884 106.884C100.458 121.311 80.9655 125.209 71.3477 115.591L84.4087 128.652C94.0265 138.27 113.519 134.371 127.946 119.945Z",
    stroke: "url(#paint1_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.884 106.884L127.946 119.945",
    stroke: "url(#paint2_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.377 118.852L109.438 131.913",
    stroke: "url(#paint3_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.853 88.3765L139.914 101.437",
    stroke: "url(#paint4_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0382 5.39673C89.1477 10.2872 91.1299 20.1984 98.4656 27.5341C105.801 34.8697 115.712 36.852 120.603 31.9614C125.493 27.0711 123.511 17.1599 116.175 9.82422C108.84 2.48855 98.9286 0.506305 94.0382 5.39673Z",
    stroke: "url(#paint5_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8244 34.1751C84.4888 26.8396 82.5065 16.9284 87.3971 12.0379L94.0381 5.39673C89.1479 10.2872 91.1301 20.1984 98.4657 27.534C105.801 34.8697 115.713 36.852 120.603 31.9614L113.962 38.6028C109.071 43.493 99.1602 41.5107 91.8244 34.1751Z",
    stroke: "url(#paint6_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4653 27.5344L91.824 34.1758",
    stroke: "url(#paint7_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.876 33.6193L101.235 40.2603",
    stroke: "url(#paint8_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3799 18.1239L85.7385 24.7651",
    stroke: "url(#paint9_linear_26951_23025)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5424 31.0089C69.9994 31.1688 69.9993 31.8309 69.5423 31.9906C62.4752 34.4598 60.0472 36.8129 57.4863 43.6539C57.3205 44.0969 56.6791 44.097 56.5131 43.6541C53.95 36.8157 51.5244 34.4626 44.4576 31.9911C44.0006 31.8312 44.0007 31.1691 44.4577 31.0094C51.5248 28.5402 53.9528 26.1871 56.5137 19.3461C56.6795 18.9031 57.3209 18.903 57.4869 19.3459C60.05 26.1843 62.4756 28.5374 69.5424 31.0089Z",
    fill: "url(#paint10_linear_26951_23025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26951_23025",
    x1: 128.154,
    y1: 88.955,
    x2: 25.5977,
    y2: 123.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26951_23025",
    x1: 141.127,
    y1: 98.0591,
    x2: 25.8565,
    y2: 136.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26951_23025",
    x1: 127.797,
    y1: 113.308,
    x2: 106.466,
    y2: 120.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26951_23025",
    x1: 109.29,
    y1: 125.276,
    x2: 87.9589,
    y2: 132.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26951_23025",
    x1: 139.765,
    y1: 94.7999,
    x2: 118.434,
    y2: 101.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26951_23025",
    x1: 91.7182,
    y1: 18.4174,
    x2: 143.865,
    y2: 35.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26951_23025",
    x1: 85.1221,
    y1: 23.0469,
    x2: 143.734,
    y2: 42.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26951_23025",
    x1: 91.8994,
    y1: 30.8007,
    x2: 102.746,
    y2: 34.4514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26951_23025",
    x1: 101.31,
    y1: 36.8853,
    x2: 112.156,
    y2: 40.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26951_23025",
    x1: 85.814,
    y1: 21.3901,
    x2: 96.6603,
    y2: 25.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26951_23025",
    x1: 70.6818,
    y1: 31.2787,
    x2: 25.3018,
    y2: 47.1188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26951_23025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselItem1);
export default __webpack_public_path__ + "static/media/carousel_item_1.326e5b45b0375367c48d0c617f7f3fe1.svg";
export { ForwardRef as ReactComponent };